import { FaDownload, FaFileExcel, FaFileImage, FaFilePdf, FaFileWord } from "react-icons/fa";

interface RenderMessageContentProps {
    url: string;
    fileName?: string;
}

const renderMessageContent: React.FC<RenderMessageContentProps> = ({ url, fileName }) => {
    url = url.replace(/^'(.*)'$/, '$1');

    const getFileTypeIcon = (fileUrl: string) => {

        const fileExtension = fileUrl.split('.').pop()?.toLowerCase(); // Dosya uzantısını al

        switch (fileExtension) {
            case 'pdf':
                return <FaFilePdf style={{ fontSize: '20px', color: 'red' }} />;
            case 'doc':
            case 'docx':
                return <FaFileWord style={{ fontSize: '20px', color: 'blue' }} />;
            case 'xls':
            case 'xlsx':
                return <FaFileExcel style={{ fontSize: '20px', color: 'green' }} />;
            case 'jpg':
            case 'jpeg':
            case 'png':
            case 'gif':
                return <FaFileImage style={{ fontSize: '20px', color: 'orange' }} />;
            default:
                return <FaDownload style={{ fontSize: '20px', color: 'black' }} />;
        }
    };

    const icon = getFileTypeIcon(url);

    return (
        <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px', padding: '10px', border: '1px solid #ddd', borderRadius: '8px' }}>
            <a href={url} target={'_blank'} download style={{
                display: 'flex',
                alignItems: 'center',
                textDecoration: 'none',  // Alt çizgi çıkmasın
                color: 'inherit' // Yazı rengi kalıcı olsun, hover sırasında da değişmesin
            }}>   {icon}
                <div style={{ marginLeft: '10px', textDecoration: 'none', color: 'white', fontSize: '14px' }}>
                    {fileName || 'Dosyayı İndirmek İçin Tıklayınız'}
                </div>
                <FaDownload style={{ marginLeft: '5px', fontSize: '14px', color: 'white' }} />
            </a>
        </div>
    );
};

export default renderMessageContent;
